import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "flex flex-row-reverse w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-4 border-b-4 border-h-primary-800 custom-card mt-4" }, {
      header: _withCtx(() => [
        _createElementVNode("h6", _hoisted_1, "Item " + _toDisplayString(_ctx.itemIndex + 1), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("p", {
          class: "flex flex-wrap w-full",
          innerHTML: _ctx.item?.getHTML()
        }, null, 8, _hoisted_2)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_Button, {
            id: `card-item-edit-btn`,
            class: "btn-simple w-fit !p-0 !px-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEdit()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { name: "hi-solid-pencil" }),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.edit")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "btn-delete w-fit",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDeleteModal()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { name: "md-delete" }),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.delete")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ConfirmDialog, {
      group: `item-card-${_ctx.itemIndex}`,
      class: "custom-dialog",
      draggable: false,
      style: { width: '80vw', maxWidth: '700px' }
    }, null, 8, ["group"])
  ], 64))
}